import React from "react";
import { showInIQD } from "../../customFunction/Numeral/CurrencyFormat";
import dayjs from "dayjs";
import ShowPaginationData from "../../components/UI/TableView/ShowPaginationData";
import { editCurrentUser } from "../../store/actions/usersAction";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

export default function MembershipsScreen() {
  const { columns, id, label, url, href } = {
    id: 'memberships', label: 'memberships',
    href: '/memberships',
    columns: [{ label: '#', value: a => a._id.slice(0,8) },
    { label: 'name', sort: 'userName', classnames: () => 'font-[Montserrat]', value: (a) => a.userName },
    { label: 'price', sort: 'originalDocument.package.price.iqd', value: (a) => showInIQD(a.originalDocument.package.price.value, 'USD') + ' - ' + showInIQD(a.originalDocument.package.price.iqd) },
    { label: 'phoneNumber', sort: 'phone', value: (a) => a.phone },
    { label: 'date', sort: 'originalDocument.createdAt', value: (a) => dayjs(a.originalDocument.createdAt).format('YYYY-MM-DD HH:mm') },
    ],
    url: (centerId) => `/memberships?startDate=${dayjs().format('YYYY-MM-DD')}&endDate=${dayjs().format('YYYY-MM-DD')}&` + centerId,
  }
  const history = useHistory();
  

  return (
    <div className="flex flex-col items-center w-full bg-white">
      <ShowPaginationData defaultSort={[{ sort: 'createdAt', sortBy: 1 }]} hrefId={null} onClickItem={(data) => { 
        editCurrentUser(data.originalDocument.user)
        setTimeout(() => {
          history.push(`/users/update/printPackage`);
        }, 50);
      }} rightButton={<div className="cursor-pointer" >
      </div>} columns={columns} href={href} id={id} label={label} url={url} />
    </div>
  );
}
